import m from "./ghl-ui.es1163.js";
import { createTheme as i } from "./ghl-ui.es827.js";
import s from "./ghl-ui.es1133.js";
import p from "./ghl-ui.es1141.js";
import { composite as a } from "./ghl-ui.es863.js";
const c = (t) => {
  const {
    borderRadius: r,
    boxShadow2: e,
    baseColor: o
  } = t;
  return Object.assign(Object.assign({}, m), {
    borderRadius: r,
    boxShadow: e,
    color: a(o, "rgba(0, 0, 0, .85)"),
    textColor: o
  });
}, n = i({
  name: "Tooltip",
  common: s,
  peers: {
    Popover: p
  },
  self: c
}), d = n;
export {
  d as default
};
